"use client";

import Link from "@/app/[lang]/_components/Link";
import { tGlob } from "@/app/[lang]/_t-glob/t-glob";
import type { Lang } from "@/langs";
import { Tabs, TabsList, TabsTrigger } from "@borderless/ui/components/tabs";
import { usePathname } from "next/navigation";

export function StoryPlaylistSwitcher(props: { lang: Lang }) {
  const pathname = usePathname();
  const lastPathnameSegment = pathname.split("/").pop();
  const defaultValue =
    lastPathnameSegment === "playlists" ? "playlists" : "stories";

  return (
    <Tabs className="mx-auto flex w-fit gap-2 pb-8" defaultValue={defaultValue}>
      <TabsList>
        <TabsTrigger value="stories" asChild>
          <Link href="/stories" className="flex">
            {tGlob("Stories", props.lang)}
          </Link>
        </TabsTrigger>
        <TabsTrigger value="playlists" asChild>
          <Link href="/stories/playlists" className="flex">
            {tGlob("Playlists", props.lang)}
          </Link>
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
